import type { TTerm } from '@/types'
import { LOCALES } from '@/common'
import { SOURCES, TAGS, TYPES } from '@/data/raw'

export default {
  id: `bitcoin`,

  name: {
    [LOCALES.EN_US]: `Bitcoin`,
  },

  label: {
    [LOCALES.EN_US]: ``,
  },

  definition: {
    [LOCALES.EN_US]: ``,
  },

  type: [TYPES.concept, TYPES.protocol],

  tags: [],
} as const satisfies TTerm
